import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { NetworkConnectionService } from '../services/network-connection/network-connection.service';

@Injectable({
  providedIn: 'root',
})
export class RouterGuard implements CanActivate {
  constructor(private network: NetworkConnectionService) { }

  canActivate(): Observable<boolean> {
    return this.network.check();
  }

}
